import {
  updateResourceState,
  createResourceReducer,
  RESOURCE,
  RECORD_FIELD
} from '@unicus/react-ui-kit';
import {
  TREATMENT,
  TREATMENT_ACCEPTED_TREATMENT_PARTNER,
  TREATMENT_ACCEPTED_TREATMENT_PARTNER_FINISHED,
  TREATMENT_CANCEL,
  TREATMENT_CANCEL_FINISHED,
  TREATMENT_CLOSE_CANCELLATION,
  TREATMENT_CONCLUDE,
  TREATMENT_CONCLUDE_FINISHED,
  TREATMENT_MY_TREATMENT_PARTNER,
  TREATMENT_MY_TREATMENT_PARTNER_FINISHED,
  TREATMENT_OPEN_CANCELLATION
} from './treatmentActions';

const handleError = (state, action) => {
  return updateResourceState(state, action, RESOURCE, () => ({
    myTreatmentPartnerLoading: false,
    treatmentPartnerAcceptingId: null,
    loading: false,
    saving: false,
    canceling: false
  }));
};

const treatmentReducer = createResourceReducer(
  TREATMENT,
  [],
  {
    [TREATMENT_CONCLUDE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: true,
        [RECORD_FIELD]: {
          ...action.payload
        }
      }));
    },

    [TREATMENT_CONCLUDE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          saving: false,
          editing: false,
          [RECORD_FIELD]: {
            ...action.payload.data.result
          }
        };
      });
    },

    [TREATMENT_MY_TREATMENT_PARTNER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          myTreatmentPartnerLoading: true
        };
      });
    },

    [TREATMENT_MY_TREATMENT_PARTNER_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          myTreatmentPartnerLoading: false,
          myTreatmentPartners: action.payload.data.result
        };
      });
    },

    [TREATMENT_ACCEPTED_TREATMENT_PARTNER](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          treatmentPartnerAcceptingId: action.payload
        };
      });
    },

    [TREATMENT_ACCEPTED_TREATMENT_PARTNER_FINISHED](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ myTreatmentPartners = [], treatmentPartnerAcceptingId }) => {
          return {
            treatmentPartnerAcceptingId: null,
            myTreatmentPartners: myTreatmentPartners.filter(
              (c) => c.id !== treatmentPartnerAcceptingId
            )
          };
        }
      );
    },

    [TREATMENT_CANCEL](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          canceling: true
        };
      });
    },

    [TREATMENT_CANCEL_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          canceling: false
        };
      });
    },

    [TREATMENT_OPEN_CANCELLATION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          cancellation: true
        };
      });
    },

    [TREATMENT_CLOSE_CANCELLATION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          cancellation: false
        };
      });
    }
  },
  handleError
);

export default treatmentReducer;
